$( document ).ready(function() {
  $(document).on('change', '.js-change-select-key-configuration', function(e) {
    $.ajax({type: 'GET', url: $(e.currentTarget).data('url'), data: {key: $(this).val()}})
  });
});
